import { PortalPermissionsAdminSettings } from "@features/portal-administration/components/PortalPermissionsAdminSettings";
import { actualStaffRolesQueryOptions } from "@features/staff-roles/queries";
import { canAccessPortalAdministration } from "@features/portal-administration/access";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/admin/permissions")({
    beforeLoad: async ({ context }) => {
        const actualRoles = await context.queryClient.ensureQueryData(actualStaffRolesQueryOptions());

        if (!canAccessPortalAdministration(actualRoles)) {
            throw redirect({ to: "/home" });
        }
    },
    component: RouteComponent,
});

function RouteComponent() {
    return <PortalPermissionsAdminSettings />;
}
